import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { SITE_LINKS } from '@shared/constants/site-links.constants';
import { User } from '@shared/models/user/user.model';
import { AuthService } from '@shared/services/auth/auth.service';
import { UserStore } from '@shared/stores/user/user.store';
import { buildUrl } from '@shared/utilities/common.utils';
import { ButtonComponent, ButtonThemes } from "../button/button.component";
import { Customer } from '@shared/models/customer/customer.model';
import { CustomerStore } from '@shared/stores/customer/customer.store';
import { ROUTE_PARAMS } from '@shared/constants/route-params.constants';

@Component({
    selector: 'avenir-header-user-menu',
    imports: [ButtonComponent],
    templateUrl: './header-user-menu.component.html',
    styleUrl: './header-user-menu.component.scss'
})
export class HeaderUserMenuComponent {
  readonly BUTTON_THEME = ButtonThemes;
  @Input() customerId: string = '';
  user!: User;
  userAcronym: string = '';
  displayMenu: boolean = false;
  profileUrl: string = '';
  accountId: string = '';
  accountName: string = '';
  customers: Customer[] = [];
  userId: any;

  constructor(
    private authService: AuthService,
    private userStore: UserStore,
    private router: Router,
    private route: ActivatedRoute,
    protected customerStore: CustomerStore
  ) { }

  ngOnInit(): void {
    this.userStore.user$.subscribe(user => {
      this.user = this.userStore.getUser();
      this.extractUserAcronymAndOtherDetails();
      this.profileUrl = buildUrl(SITE_LINKS.PROFILE.BASE, this.customerId, this.user?.userId);
    })
  }

  navigateTo(url: string) {
    this.router.navigateByUrl(url);
  }

  extractUserAcronymAndOtherDetails(): void {
    if (this.user && this.user.firstname && this.user.lastname) {
      this.userAcronym = `${this.user.firstname.charAt(0)}${this.user.lastname.charAt(0)}`;
      this.accountId = this.user.customers[0].legacyId ? this.user.customers[0].legacyId?.trim() : '';
      this.accountName = this.user.customers[0].name ? this.user.customers[0].name?.trim() : '';

      this.customers = this.user.customers;

    } else {
      this.userAcronym = '';
    }
  }

  goToUserProfile() {
    this.profileUrl = buildUrl(SITE_LINKS.PROFILE.BASE, this.customerId, this.user?.userId);
    this.router.navigateByUrl(this.profileUrl);
  }

  onLogout(): void {
    this.authService.logout()
      .subscribe({
        next: (data) => {
          this.user =  {
            firstname: '',
            middlename:'',
            department:'',
            lastname: '',
            fullname: '',
            imageUrl: '',
            email: '',
            userId: '',
            clients: [],
            mobileNumber: '',
            alternateNumber: '',
            customers: [],
            userSettings: {
              emailNotification: false,
              multiFactorAuthEmail: false,
              multiFactorAuthSms: false,
              smsNotification: false,
              userSettingsId: ''
            },
            countryCode: '',
            position: ''
          };
          this.userAcronym = '';
          this.authService.resetAuth();
        },
        error: (error) => {
          console.error(error);
        }
      });
  }
}